import React from 'react';
import { NonTextLink } from '../../../commonTypes/links';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import Icon from '../../Icon';
import {
  BadgeLink,
  IconWrapper,
  MarketingPromoBadgeCalloutShape,
  MarketingPromoBadgeContainer,
  MarketingPromoBadgeMainShape,
  MarketPromoBadgeCalloutText,
  MarketPromoBadgeMainShapeText,
} from './styles';

export type BadgeSize = 'small' | 'large';

type MarketingPromoBadgeShapeWithTextProps = {
  text: string;
  size: BadgeSize;
};

const MarketingPromoBadgeCallout: React.FC<MarketingPromoBadgeShapeWithTextProps> = ({
  text,
  size,
}) => (
  <MarketingPromoBadgeCalloutShape size={size}>
    <MarketPromoBadgeCalloutText size={size}>{text}</MarketPromoBadgeCalloutText>
  </MarketingPromoBadgeCalloutShape>
);

const MarketingPromoBadgeMain: React.FC<MarketingPromoBadgeShapeWithTextProps> = ({
  text,
  size,
}) => (
  <MarketingPromoBadgeMainShape size={size}>
    <MarketPromoBadgeMainShapeText size={size}>{text}</MarketPromoBadgeMainShapeText>
    {size === 'small' && (
      <IconWrapper>
        <Icon name="chevron" size="small" />
      </IconWrapper>
    )}
  </MarketingPromoBadgeMainShape>
);

type MarketingPromoBadgeImageProps = {
  heading: string;
  subheading: string;
  size: BadgeSize;
} & ComponentProps;

const MarketingPromoBadgeImage: React.FC<MarketingPromoBadgeImageProps> = ({
  heading,
  subheading,
  size,
  ...props
}) => (
  <MarketingPromoBadgeContainer {...componentProps(props)}>
    {size === 'large' ? (
      <>
        <MarketingPromoBadgeCallout text={heading} size={size} />
        <MarketingPromoBadgeMain text={subheading} size={size} />
      </>
    ) : (
      <>
        <MarketingPromoBadgeMain text={heading} size={size} />
        <MarketingPromoBadgeCallout text={subheading} size={size} />
      </>
    )}
  </MarketingPromoBadgeContainer>
);

type MarketingPromoBadgeProps = {
  heading: string;
  subheading: string;
  size: BadgeSize;
  link?: NonTextLink;
} & ComponentProps;

const MarketingPromoBadge: React.FC<MarketingPromoBadgeProps> = ({
  heading,
  subheading,
  size,
  link,
  ...props
}) =>
  link ? (
    <BadgeLink href={link.url} aria-label={link.screenReaderText} onClick={link.onClick}>
      <MarketingPromoBadgeImage
        size={size}
        heading={heading}
        subheading={subheading}
        {...componentProps(props)}
      />
    </BadgeLink>
  ) : (
    <MarketingPromoBadgeImage
      size={size}
      heading={heading}
      subheading={subheading}
      {...componentProps(props)}
    />
  );

export default applyComponentTheme(MarketingPromoBadge, 'MarketingPromoBadge');
